<template>
    <div class="center">
        <button class="botonRestar" @click="restar()" :disabled="Disabled" :data-testid="resolveTestId('BUTTON_RESTAR')">-</button>
        <input class="inputNumber" :value="cantidadLocal" @input="onInput($event)" @blur="validar()" :disabled="Disabled" :data-testid="resolveTestId('INPUT')">         
        <button class="botonSumar" @click="sumar()" :disabled="Disabled" :data-testid="resolveTestId('BUTTON_SUMAR')">+</button>
    </div>    
</template>
<script>

export default {
  name: 'InputNumber',
  props: {
        modelValue: {
            type: [String, Number],
            default: ''
        },
    AdmiteDecimales:String,
    Minimo:String,
        Disabled:Boolean,
        testIdPrefix: {
            type: String,
            default: ''
        }
  },
  components: {},
  data() {
    return {
      
      old_cantidad:this.Minimo,
      admiteDecimales:this.AdmiteDecimales,
      minimo: this.Minimo,
            cantidadLocal: this.modelValue === undefined || this.modelValue === null
                ? ''
                : String(this.modelValue),
    }
  },
  methods:
  {
    sumar(){
        let sum = this.admiteDecimales != 'N'? 0.1 : 1;
        let cantidadAux = this.admiteDecimales != 'N'? parseFloat(this.cantidadLocal):parseInt(this.cantidadLocal);
        let suma = this.admiteDecimales != 'N'?(sum + cantidadAux).toFixed(1):sum + cantidadAux;

        this.old_cantidad = this.cantidadLocal;
        this.cantidadLocal = suma.toString();
        
        this.cambio();
    },
    restar(){
        let minus = this.admiteDecimales != 'N'? 0.1 : 1;

        let cantidadAux = this.admiteDecimales != 'N'? parseFloat(this.cantidadLocal):parseInt(this.cantidadLocal);
        let resta = this.admiteDecimales != 'N'?(cantidadAux - minus).toFixed(1):cantidadAux - minus;

        let min = this.admiteDecimales != 'N'?parseFloat(this.minimo).toFixed(1):this.minimo;
        if(resta>=min){
            this.old_cantidad = this.cantidadLocal;
            this.cantidadLocal = resta.toString();
            
            this.cambio();
        }
    },
    onInput(event){       

        this.cantidadLocal = event && event.target ? event.target.value : this.cantidadLocal;

        if(this.admiteDecimales!='N'){
            //Corregimos la entrada
            if(this.cantidadLocal== "" || this.cantidadLocal ==".")
                this.cantidadLocal=this.minimo;
            
        }else if(this.cantidadLocal.length == 0){
            this.cantidadLocal =this.minimo;
        }

        var regExp = this.admiteDecimales=='N'? /^([0-9]+)$/ : /^([0-9]+\.?[0-9]?)$/;

        var matches = regExp.exec(this.cantidadLocal);

        
        if (!matches) {
            this.cantidadLocal = this.old_cantidad;
        } else{
            // let auxOld = this.old_cantidad;

            // if(this.old_cantidad[this.old_cantidad.length-1]== "."){
            //     auxOld = this.old_cantidad + this.minimo[this.minimo.length-1];
            //     auxOld = auxOld ==this.minimo? auxOld:this.old_cantidad+"0";
            // }
            this.cambio();
            this.old_cantidad = this.cantidadLocal;
        }
            
        
    },
    validar(){
        if(this.cantidadLocal[this.cantidadLocal.length-1]== ".")
            this.cantidadLocal = this.cantidadLocal + this.minimo[this.minimo.length-1];
        
        if(this.admiteDecimales != "N" && !this.cantidadLocal.includes(".")){
            let aux = this.cantidadLocal+".0";
            if(parseInt(aux)>0)
                this.cantidadLocal = aux;
            else
                this.cantidadLocal = this.cantidadLocal + "." + this.minimo[this.minimo.length-1];
        }
            

        if(this.old_cantidad[this.old_cantidad.length-1]== "."){
           let aux = (this.old_cantidad + this.minimo[this.minimo.length-1]);
           this.old_cantidad = aux ==this.minimo? aux:this.old_cantidad +"0";
           
        }

        if(this.cantidadLocal<= this.minimo)
            this.cantidadLocal = this.minimo;
            
        this.cambio();
    },   
    cambio(){
            this.$emit('update:modelValue', this.cantidadLocal)
        },
        resolveTestId(suffix) {
            if (!this.testIdPrefix) {
                return undefined
            }

            return `${this.testIdPrefix}.${suffix}`
    } 
    },
  watch: {
        modelValue(val) {
      this.cantidadLocal = val === undefined || val === null ? '' : String(val);
    }
  },
  }
</script>

<style>
.botonRestar{
    border-top-left-radius: 4px !important;
    border-bottom-left-radius: 4px !important;    
    margin-right: 0px!important;  
    width: 25% !important;
    height: 100%;
    background: var(--main-color) !important;
    border-color: #66b1ff !important;
    color: #fff !important;
    cursor: pointer;
    line-height: 1;
    white-space: nowrap;
    border: 1px solid var(--main-color) ;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
    float:left;
}
.botonSumar{
    margin-top: 0px !important;
    border-top-right-radius: 4px !important;
    border-bottom-right-radius: 4px !important; 
    width: 25% !important;
    height: 100% !important;
    background: var(--main-color) !important;
    border-color: #66b1ff !important;
    color: #fff !important;
    cursor: pointer;
    line-height: 1;
    white-space: nowrap;
    border: 1px solid var(--main-color) ;
    -webkit-appearance: none;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    outline: 0;
    -webkit-transition: .1s;
    transition: .1s;
    font-weight: 500;
    font-size: 14px;
    float:left;
}
.inputNumber{
    background-color: #FFF;
    background-image: none;
    border: 1px solid #DCDFE6 !important;
    text-align: center;
    -webkit-box-sizing: border-box;
    box-sizing: border-box;
    color: #606266;
    font-size: 80%;
    height: 100%;
    width:50%;
    line-height: 24px;    
    outline: 0;
    padding: 0 5px;
    -webkit-transition: border-color .2s cubic-bezier(.645,.045,.355,1); 
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
    float:left;
} 
.center{
    height:26px;
    width:98px;
    position: relative;
}
</style>

<style scoped>
.botonSumar{
margin-top: 0px !important;
}

</style>

